import React, { FC, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { InputChangeEvent } from "../../common/model/InputChangeEvent";
import { InputFormEvent } from "../../common/model/InputFormEvent";
import { UserAuthRequirements } from "../../types/user";
import "./loginForm.style.scss";
import { colors } from "../../constants/site-content";

// Define the Props type correctly without `| any`
type Props = {
  onSubmit: (e: InputFormEvent) => void;
  onChange: (e: InputChangeEvent) => void;
  errors: {
    email?: string;
    password?: string;
    summary?: string;
  };
  successMessage: string;
  user: UserAuthRequirements;
};

export const LoginForm: FC<Props> = ({
  onSubmit,
  onChange,
  errors,
  successMessage,
  user,
}) => {
  useEffect(() => {
    console.log("my errorrs", errors);
  }, [errors]);
  return (
    <div className="container">
      <form action="/" onSubmit={onSubmit} className="auth_form" noValidate>
        <h2 className="card-heading">Login to Croqee</h2>
        {successMessage && <p className="success-message">{successMessage}</p>}
        <TextField
          required
          label="Email"
          id="email"
          name="email"
          onChange={onChange}
          placeholder="Your Email address"
          error={Boolean(errors.email || errors.summary)}
          helperText={errors.email || errors.summary}
          className="auth_form-input"
        />
        <TextField
          required
          label="Password"
          id="password"
          type="password"
          name="password"
          onChange={onChange}
          placeholder="Your Password"
          error={Boolean(errors.password || errors.summary)}
          helperText={errors.password || errors.summary}
          className="auth_form-input"
        />
        <Button
          className="auth_form-input"
          variant="outlined"
          type="submit"
          sx={{
            backgroundColor: colors.brandColor,
            color: "#fff",
            height: "42px",
            fontSize: "16px",
            "&:hover": {
              color: colors.brandColor,
            },
          }}
        >
          Login
        </Button>
      </form>
    </div>
  );
};
